module.exports = __webpack_public_path__ + "static/media/MyHistory_Selected@3x.19ee358b.png";